// extracted by mini-css-extract-plugin
export default {"commute":"styles_commute__eBVbT","icon":"styles_icon__VP9Uv","info":"styles_info__XoJZt","name":"styles_name__lQlcj","commuteTime":"styles_commuteTime__fBsYH"};